export type FitterType =
  | 'CENTER'
  | 'RELAY_POINT'
  | 'MOBILE'
  | 'CENTER_AND_MOBILE';
